window.chatWidget = function () {
    return {
        isOpen: false,
        messages: [],
        newMessage: '',
        conversationId: null,
        unreadCount: 0,
        isLoading: false,
        loaded: false,
        pollInterval: null,

        init() {
            this.loadUnreadCount();
            this.startPolling();
        },

        async loadUnreadCount() {
            try {
                const response = await fetch('/chat/unread-count');
                const data = await response.json();
                this.unreadCount = data.count;
            } catch (error) {
                console.error('Error loading unread count:', error);
            }
        },

        async loadMessages() {
            if (!this.loaded) {
                this.isLoading = true;
            }
            try {
                const response = await fetch('/chat/messages');
                const data = await response.json();
                this.messages = data.messages || [];
                this.conversationId = data.conversation_id;
                this.unreadCount = 0;

                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            } catch (error) {
                console.error('Error loading messages:', error);
            } finally {
                this.isLoading = false;
                this.loaded = true;
            }
        },

        async sendMessage() {
            if (!this.newMessage.trim()) return;

            const messageText = this.newMessage;
            this.newMessage = '';

            try {
                const response = await fetch('/chat/send', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                    },
                    body: JSON.stringify({ message: messageText })
                });

                const data = await response.json();
                if (data.success) {
                    this.messages.push(data.message);
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                }
            } catch (error) {
                console.error('Error sending message:', error);
                this.newMessage = messageText;
            }
        },

        toggleChat() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.loadMessages();
            }
        },

        closeChat() {
            this.isOpen = false;
        },

        scrollToBottom() {
            const container = this.$refs.messagesContainer;
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        },

        formatMessage(content) {
            let formatted = content.replace(/</g, '&lt;').replace(/>/g, '&gt;');

            const urlRegex = /(https?:\/\/[^\s]+)/g;
            formatted = formatted.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer" class="message-link">$1</a>');

            formatted = formatted.replace(/\n/g, '<br>');

            return formatted;
        },

        formatTime(timestamp) {
            const date = new Date(timestamp);
            const now = new Date();
            const diff = now - date;
            const hours = Math.floor(diff / 3600000);

            if (hours < 1) {
                const minutes = Math.floor(diff / 60000);
                return minutes < 1 ? 'À l\'instant' : `Il y a ${minutes}min`;
            } else if (hours < 24) {
                return `Il y a ${hours}h`;
            } else {
                return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
            }
        },

        startPolling() {
            this.pollInterval = setInterval(() => {
                if (this.isOpen && this.messages.length > 0) {
                    this.loadMessages();
                } else if (!this.isOpen) {
                    this.loadUnreadCount();
                }
            }, 30000);
        },

        destroy() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
            }
        }
    };
}
